module.exports = __webpack_public_path__ + "img/DoodleJumpNew.0b16d7ea.png";